import { baseURL } from './http.js';
import request from './request.js';

export default {
  orderCanCreate: () => request(baseURL).post('order/canCreate'),
  // 寻样查询
  getOrderList: item => request(baseURL).post('order/list', item),
  // 修改订单
  updateOrderList: item => request(baseURL).post('order/update', item),
  // 新增订单
  createOrderList: item => request(baseURL).post('order/create', item),
  // 获取订单审核信息
  getOrderCheckInfoOrderList: item => request(baseURL).post('order/getOrderCheckInfo', item),
  // 新增审核信息
  addCheckInfoOrderList: item => request(baseURL).post('order/addCheckInfo', item),
  // 寻样确认查询
  getOrderConfirmInfoOrderList: item => request(baseURL).post('order/getOrderConfirmInfo', item),
  // 批量新增确认信息
  batchAddConfirmInfoOrderList: item => request(baseURL).post('order/batchAddConfirmInfo', item),
  // 获取订单寄出信息
  getOrderDeliveryInfoOrderList: item => request(baseURL).post('order/getOrderDeliveryInfo', item),
  // 批量新增发出信息
  batchAddDeliveryInfo: item => request(baseURL).post('order/batchAddDeliveryInfo', item),
  // 批量采购收货
  batchReceipt: item => request(baseURL).post('order/batchReceipt', item),
  // 批量申请人收货
  batchGet: item => request(baseURL).post('order/batchGet', item),
  // 新增反馈信息
  addFeedback: item => request(baseURL).post('order/addFeedback', item),
  // 批量新增订单
  batchCreateOrder: item => request(baseURL).post('order/batchCreate', item),
  // 寻样反馈列表
  getOrderGetInfoList: item => request(baseURL).post('order/getOrderGetInfo', item),
  // 我的寻样查询
  getMyOrderList: item => request(baseURL).post('order/myList', item),
  // 批量审核
  batchAddCheckInfo: item => request(baseURL).post('order/batchAddCheckInfo', item),

  // 日志管理
  bizChangeLog: item => request(baseURL).post('bizChangeLog/list', item),
  getOrderDetail: val => request(baseURL).get(`order/get?id=${val}`),
  getOrderLeadInfo: item => request(baseURL).post('order/getOrderLeadInfo', item),
  approvalOrderLead: item => request(baseURL).post('order/approval', item),
  changeOrderLead: item => request(baseURL).post('order/change', item),
};